import { RELATIONS_NS } from '@content-registration/xml/shared';

const GRANT_ID_VERSION = '0.2.0';
export const GRANT_ID_NS = `http://www.crossref.org/grant_id/${GRANT_ID_VERSION}`;
export { RELATIONS_NS };
const GRANT_ID_SCHEMA_URL = `https://www.crossref.org/schemas/grant_id${GRANT_ID_VERSION}.xsd`;
const XSI_NS = 'http://www.w3.org/2001/XMLSchema-instance';
const XML_NS = 'http://www.w3.org/XML/1998/namespace';

/**
 * Grant ID document helpers. Namespace, schema location, and version follow
 * Grant ID 0.2.0. Element helpers follow the shared `xml-helpers.ts` pattern,
 * using the grant_id namespace.
 */
export function createGrantIdDocument(): Document {
  const doc = document.implementation.createDocument(
    GRANT_ID_NS,
    'doi_batch',
    null
  );

  const root = doc.documentElement;
  root.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xsi', XSI_NS);
  root.setAttributeNS(
    XSI_NS,
    'xsi:schemaLocation',
    `${GRANT_ID_NS} ${GRANT_ID_SCHEMA_URL}`
  );
  root.setAttribute('version', GRANT_ID_VERSION);

  return doc;
}

function appendNsElement(
  parent: Element,
  ns: string,
  name: string,
  text?: string | null,
  attrs?: Record<string, string>
): Element {
  const el = parent.ownerDocument!.createElementNS(ns, name);

  if (text != null) {
    el.textContent = text;
  }

  for (const [key, value] of Object.entries(attrs ?? {})) {
    // xml:lang belongs to the XML namespace, not the element namespace.
    if (key === 'xml:lang') {
      el.setAttributeNS(XML_NS, key, value);
    } else {
      el.setAttribute(key, value);
    }
  }

  parent.appendChild(el);
  return el;
}

export const appendGrantElement = (
  parent: Element,
  name: string,
  text?: string | null,
  attrs?: Record<string, string>
): Element => appendNsElement(parent, GRANT_ID_NS, name, text, attrs);

export function appendGrantElementIf(
  parent: Element,
  name: string,
  text?: string | null,
  attrs?: Record<string, string>
): Element | null {
  if (!text) return null;
  return appendGrantElement(parent, name, text, attrs);
}

export const appendRelationsElement = (
  parent: Element,
  name: string,
  text?: string | null,
  attrs?: Record<string, string>
): Element => appendNsElement(parent, RELATIONS_NS, name, text, attrs);
